import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { EventPremisesCard } from './ui/event_premises_card.js';

export { EventPremisesCard } from './ui/event_premises_card.js';

/** Entrada de catálogo do `event_premises` — o último emit segue o leitor. */
export const eventPremisesEntry: GenUiEntry<Extract<ChatUi, { kind: 'event_premises' }>> = {
  kind: 'event_premises',
  slot: 'chat',
  policy: { anchorAtLatestEmitter: () => true },
  render: (props) => <EventPremisesCard {...props} />,
};
